import React from 'react';
import {FormControlLabel, Checkbox} from '@mui/material';
import SVGIcons, {SVGType} from '@components/SVGIcon';
import {CheckboxProps} from './Checkbox.type';
import style from './Checkbox.style.module.scss';

const getIcon = (type: string) => <SVGIcons type={type as SVGType} />;

export function CheckboxElement(props: CheckboxProps) {
  const getLabel = () => (
    <span className={style.label}> {props.labelElement || props.label}</span>
  );

  return (
    <FormControlLabel
      label={getLabel()}
      className={`${style.container} ${props.className}`}
      control={
        <Checkbox
          checked={
            props.booleanCheck
              ? props.isChecked
              : props?.checked?.includes(props.label)
          }
          onChange={(event) => props?.handleChange(event, props.label)}
          icon={getIcon('uncheckbox-svg')}
          checkedIcon={getIcon('checkbox-svg')}
        />
      }
      style={{fontSize: '14px'}}
    />
  );
}
